import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
@Component({
  selector: 'app-frequentlyquestions',
  templateUrl: './frequentlyquestions.component.html',
  styleUrls: ['./frequentlyquestions.component.scss'],
})
export class FrequentlyquestionsComponent implements OnInit {
  public contactDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  public freqAskQues: any = [];
  images: any = [];
  activeIndex: any;
  displayCustom: boolean;

  constructor(public productService: ProductService) {}
  ngOnInit(): void {
    this.getAboutUsDetails();
    this.getFrequentlyQuestions();
  }
  getAboutUsDetails() {
    this.productService.getContactDetails().subscribe((data) => {
      this.contactDetails = data;
      this.images.push(this.contactDetails.bannerImage);
    });
  }
  getFrequentlyQuestions() {
    this.productService.getFaq().subscribe((data) => {
      this.freqAskQues = data;
    });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
